import { useRef } from "react";
import { useNexusCanvas } from "@/hooks/useNexusCanvas";

export const NexusBackdrop = ({ reduced }) => {
  const ref = useRef(null);
  useNexusCanvas(ref, !reduced);
  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 z-0">
      {reduced ? (
        <div className="static-backdrop absolute inset-0" data-testid="nexus-static-backdrop" />
      ) : (
        <canvas ref={ref} className="absolute inset-0 h-full w-full" data-testid="nexus-canvas" />
      )}
      <div className="grid-lines" />
      <div className="noise" />
      <div className="vignette" />
    </div>
  );
};
